
import Vue from "vue";
import store from "@/store";
import router from "@/router";
import { validationMixin } from "vuelidate";
import AppLoading from "@/components/UI/AppLoading.vue";
import ContactUsComponent from "@/components/admin/landing/about-us/ContactUs.vue";
import CertificatesComponent from "@/components/admin/landing/about-us/Certificates.vue";
import MoreBoxContentComponent from "@/components/admin/landing/about-us/MoreBoxContent.vue";
import CatalogsComponent from "@/components/admin/landing/about-us/Catalogs.vue";
// import CreateVideoComponent from "@/components/admin/landing/home-page/CreateVideo.vue";
import { required, minLength, minValue } from "vuelidate/lib/validators";

export default Vue.extend({
  name: "AdminAddProduct",
  mixins: [validationMixin],
  components: {
    AppLoading,
    ContactUsComponent,
    CertificatesComponent,
    MoreBoxContentComponent,
    CatalogsComponent
    // CreateVideoComponent
  },
  data() {
    return {
      chosenFile: "" as string | FormData,
      chosenFiles: "" as string | FormData,
      defaultImage: require("@/assets/img/default-product.jpg"),
      url: "https://webapi.vip-chef.ir/images/landing/"
    };
  },
  methods: {
    submitMainBanner() {
      store.dispatch("admin/uploadAboutUsMainBanner", {
        image: this.chosenFile,
      });
    },
    submitContent() {
      const data = {
        title: this.title,
        text: this.description,
        language: this.language,
      };
      store.dispatch("admin/submitAboutUsContent", data);
    },
    uploadMainBannerImage(e: any): void {
      const file = e.target.files[0];
      if (file) {
        const fileReader = new FileReader();

        fileReader.onload = (event) => {
          store.dispatch(
            "admin/updateMainBannerAboutUs",
            event?.target?.result
          );
        };
        fileReader.readAsDataURL(file);

        // save choosed file
        let formData = new FormData();
        formData.append("image", file);
        this.chosenFile = formData;
      }
    },
    uploadImages(files: any): void {
      let formData = new FormData();

      for (let fileIndex in files) {
        const file = files[fileIndex];

        formData.append("images", file);
      }

      this.chosenFiles = formData;
    },
    cancel(): void {
      router.push({ name: "admin-all-products" });
    },
  },
  computed: {
    languages(): any[] {
      let items: any[] = [
        {
          title: "انگلیسی",
          value: "En",
        },
        {
          title: "فارسی",
          value: "Fa",
        },
        {
          title: "عربی",
          value: "Ar",
        },
      ];
      return items;
    },

    title: {
      get(): string {
        return store.state.admin.landing.aboutUs.title;
      },
      set(value: string): void {
        store.dispatch("admin/updateAboutUsTitle", value);
      },
    },

    titleError(): string[] {
      const errors: string[] = [];
      if (!this.$v.title?.$dirty) {
        return errors;
      }
      !this.$v.title.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },

    language: {
      get(): string {
        return store.state.admin.landing.aboutUs.language;
      },
      set(value: any): void {
        store.dispatch("admin/updateAboutUsLanguage", value);
      },
    },
    languageError(): string[] {
      const errors: string[] = [];
      if (!this.$v.language?.$dirty) {
        return errors;
      }
      !this.$v.language.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    description: {
      get(): string {
        return store.state.admin.landing.aboutUs.description;
      },
      set(value: string): void {
        store.dispatch("admin/updateAboutUsDescription", value);
      },
    },
    descriptionError(): string[] {
      const errors: string[] = [];
      if (!this.$v.description?.$dirty) {
        return errors;
      }
      !this.$v.description.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    isLoading(): boolean {
      return store.state.app.loading;
    },
  },
  mounted() {
    const id = this.$route.query.id;
    if (id) {
      store.dispatch("admin/updateProductCategory", id);
    }
  },
  validations: {
    title: {
      required,
    },
    language: {
      required,
    },
    description: {
      required,
    },
  },
});
